import React, { useState } from 'react';
import '../../css/modal.css';
import { Query } from '../../types/Query';
import { createBooking } from '../../api/Booking';

interface Props {
  query: Query;
  onClose: () => void;
  onCreated: () => void;
}

const AddBookingModal: React.FC<Props> = ({ query, onClose, onCreated }) => {
  const [travelStartDate, setTravelStartDate] = useState<string>('');
  const [travelEndDate, setTravelEndDate] = useState<string>('');
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const [status, setStatus] = useState<string>('PENDING');
  const [notes, setNotes] = useState<string>('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string>('');

  const handleSubmit = async () => {
    try {
      setSaving(true);
      setError('');
      await createBooking({
        queryId: query.id,
        travelStartDate,
        travelEndDate,
        totalPrice,
        status,
        notes,
      });
      onCreated();
      onClose();
    } catch (e: any) {
      setError(e?.message || 'Failed to create booking');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Add Booking</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <div style={{ marginBottom: 8, fontSize: 14, color: '#374151' }}>
            <strong>Customer:</strong> {query.customer?.name || '—'} · <strong>Type:</strong> {query.type} · <strong>Location:</strong> {query.location}
          </div>
          <label>
            Travel Start Date
            <input type="date" value={travelStartDate} onChange={e => setTravelStartDate(e.target.value)} />
          </label>
          <label>
            Travel End Date
            <input type="date" value={travelEndDate} onChange={e => setTravelEndDate(e.target.value)} />
          </label>
          <label>
            Total Price (₹)
            <input type="number" value={totalPrice} onChange={e => setTotalPrice(Number(e.target.value || 0))} />
          </label>
          <label>
            Status
            <select value={status} onChange={e => setStatus(e.target.value)}>
              <option value="PENDING">Pending</option>
              <option value="CONFIRMED">Confirmed</option>
              <option value="CANCELLED">Cancelled</option>
            </select>
          </label>
          <label>
            Notes
            <textarea value={notes} onChange={e => setNotes(e.target.value)} />
          </label>
          {error && <div style={{ color: '#b91c1c', fontSize: 12 }}>{error}</div>}
        </div>
        <div className="modal-actions">
          <button onClick={handleSubmit} disabled={saving}>{saving ? 'Saving…' : 'Create Booking'}</button>
          <button className="secondary" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default AddBookingModal;

